<template>
  <div class="TrainingData">
    <a-tabs v-model="activeKey">
      <a-tab-pane :key="1" tab="运动记录">
        <SportRecord></SportRecord>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="训练总结">
        <DrillSummary></DrillSummary>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import SportRecord from './trainingData/SportRecord.vue'
import DrillSummary from './trainingData/DrillSummary.vue';
// import TraningDay from './trainingData/TrainingDay.vue';
// import TrainingSituation from './trainingData/TrainingSituation.vue';
// import TrainingData from './trainingData/TrainingData.vue';
export default {
  components: {
    SportRecord,
    DrillSummary
    // TraningDay,
    // TrainingSituation,
    // TrainingData,
  },
  data() {
    return {
      activeKey: 1
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.TrainingData {
  color: #ffffff;
}
</style>
